import * as React from "react"
import type { SVGProps } from "react"
const SvgFolder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M4 20.71q-.82 0-1.41-.58A2 2 0 0 1 2 18.7v-12q0-.83.59-1.4A2 2 0 0 1 4 4.7h5.18a2 2 0 0 1 1.4.58L12 6.7h8q.83 0 1.41.6.6.57.59 1.4v10q0 .82-.59 1.42a2 2 0 0 1-1.41.58zm0-2h16v-10h-8.82l-2-2H4z" />
  </svg>
)
export default SvgFolder
